<template>
  <div class="menu hero-head">
    <div class="container">
      <nav class="navbar" role="navigation" aria-label="main navigation">
        <!-- Logo -->
        <div class="navbar-brand">
          <a class="navbar-item pm-title pyroll-logo" href="/">
            <img src="../assets/img/logo.svg" alt="Logo" />
            <span class="is-ubuntu green-color">Kauppa</span>
          </a>

          <!-- Burger (mobile) -->
          <a role="button" class="navbar-burger" :class="{ 'is-active': isActive }" @click="isActive = !isActive"
            aria-label="menu" aria-expanded="false">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>

        <!-- Menu -->
        <div class="navbar-menu" :class="{ 'is-active': isActive }">
          <div class="navbar-end">
            <a class="navbar-item">
              <div class="popover is-popover-bottom">
                <a class="shopping-cart-button mt-0 popover-trigger is-relative is-flex"
                  @click.stop="toggleMenu('products')" ref="productsTrigger">
                  <span class="cart-wrapper">Tuotteet</span>
                </a>
                <products-modal v-if="openMenus.products" ref="productsModal" @close="openMenus.products = false">
                </products-modal>
              </div>
            </a>
            <a class="navbar-item">
              <div class="popover is-popover-bottom">
                <a class="shopping-cart-button mt-0 popover-trigger is-relative is-flex"
                  @click.stop="toggleMenu('search')" ref="searchTrigger">
                  <span class="cart-wrapper">
                    Haku
                    <span class="cart-icon">
                      <i class="fa-solid fa-magnifying-glass"></i>
                    </span>
                  </span>
                </a>
                <search-modal v-if="openMenus.search" ref="searchModal"></search-modal>
              </div>
            </a>
            <a class="navbar-item" v-if="this.$store.getters.getAccountInfo == null">
              <div class="popover is-popover-bottom">
                <a class="shopping-cart-button mt-0 popover-trigger is-relative is-flex"
                  @click.stop="toggleMenu('login')" ref="loginTrigger">
                  <span class="cart-wrapper">
                    Oma tili
                    <span class="cart-icon">
                      <i class="fa-solid fa-user"></i>
                    </span>
                  </span>
                </a>
                <login-modal v-if="openMenus.login" ref="loginModal"></login-modal>
              </div>
            </a>
            <a class="navbar-item" v-else>
              <div class="popover is-popover-bottom">
                <a class="shopping-cart-button mt-0 popover-trigger is-relative is-flex"
                  @click="$router.push({ name: 'Designs' })">
                  <span class="cart-wrapper">
                    Oma tilisi
                    <span class="cart-icon">
                      <i class="fa-solid fa-user"></i>
                    </span>
                  </span>
                </a>
              </div>
            </a>
            <a class="navbar-item" v-if="this.$store.getters.getAccountInfo != null">
              <div class="popover is-popover-bottom">
                <a class="shopping-cart-button mt-0 popover-trigger is-relative is-flex" @click="logout()">
                  <span class="cart-wrapper">
                    Kirjaudu ulos
                    <span class="cart-icon">
                      <i class="fa-solid fa-arrow-right-from-bracket"></i>
                    </span>
                  </span>
                </a>
              </div>
            </a>
            <a class="navbar-item">
              <div class="popover is-popover-bottom">
                <a class="shopping-cart-button mt-0 popover-trigger is-relative is-flex"
                  @click.stop="toggleMenu('cart')" ref="cartTrigger">
                  <span v-if="$store.getters.getCartSpinnerState">
                    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                  </span>
                  <span class="cart-wrapper" v-else>
                    Ostoskori
                    <span class="cart-icon">
                      <span class="cart-count" v-if="getProductsLength > 0">{{ getProductsLength }}</span>
                      <i v-if="!$store.getters.getCartSpinnerState" class="fa fa-shopping-cart" aria-hidden="true"></i>
                    </span>
                  </span>
                </a>
                <cart-modal v-if="openMenus.cart" ref="cartModal"></cart-modal>
              </div>
            </a>
          </div>
        </div>
      </nav>
    </div>
  </div>
  <div class="ribbon" v-if="getRibbonText != ''">
    <p class="font-13 is-ubuntu">{{ getRibbonText }}</p>
  </div>
  <div class="green-ribbon">
    <p class="font-13 is-ubuntu">Asiakaspalvelu arkisin klo 8 – 16  | asiakaspalvelu@packagemedia.fi | puh. 05 747 2200
      tai 050 5320575</p>
  </div>

</template>

<script>

import cartModal from "@/modals/cartModal"
import searchModal from "@/modals/searchModal"
import loginModal from "@/modals/loginModal"
import productsModal from "@/modals/productsModal"
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "PmNavbar",
  components: {
    cartModal,
    searchModal,
    productsModal,
    loginModal
  },
  data() {
    return {
      isActive: false,
      openMenus: {
        products: false,
        search: false,
        cart: false,
        login: false
      }
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    this.listLandingData()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    ...mapGetters([
      'getSavedItems',
      'getNonDraftOrderForms',
      'getOrderData',
      'getAccountInfo'
    ]),
    ...mapMutations([
      'seti18n',
      'resetStore'
    ]),
    ...mapActions([
      'listLandingData'
    ]),
    toggleBurger() {
      this.isActive = !this.isActive
    },
    switchlanguage(locale) {
      if (this.$i18n.locale == locale) return;
      this.$i18n.locale = locale
      this.seti18n(locale)
    },
    toggleMenu(name) {
      // Dont open cart menu with no products in the cart
      if (name == 'cart' && this.getProductsLength == 0) {
        this.openMenus['cart'] = false
        return
      }
      // Close all other modals
      Object.keys(this.openMenus).forEach(key => {
        this.openMenus[key] = false
      })

      // Opens only clicked modal
      this.openMenus[name] = true
    },
    handleClickOutside(event) {
      const menus = [
        { name: 'products', trigger: this.$refs.productsTrigger, modal: this.$refs.productsModal?.$el },
        { name: 'search', trigger: this.$refs.searchTrigger, modal: this.$refs.searchModal?.$el },
        { name: 'cart', trigger: this.$refs.cartTrigger, modal: this.$refs.cartModal?.$el },
        { name: 'login', trigger: this.$refs.loginTrigger, modal: this.$refs.loginModal?.$el }
      ]

      menus.forEach(({ name, trigger, modal }) => {
        if (this.openMenus[name] && modal && !modal.contains(event.target) && !trigger.contains(event.target)) {
          this.openMenus[name] = false
        }
      })
    },
    logout() {
      this.resetStore()
      this.$router.push({ name: 'Landing' })
    }
  },
  computed: {
    getProductsLength() {
      let order = this.getOrderData
      if (!order) {
        return 0
      }
      return this.getSavedItems().length + this.getNonDraftOrderForms().length
    },
    getRibbonText() {
      if (this.$store.getters.landingData != undefined) {
        let results = this.$store.getters.landingData.results
        if (results.length > 0) {
          if (results[0]['ribbon'] != '') {
            return results[0]['ribbon']
          }
        }
      }
      return ''
    }
  }
};
</script>

<style scoped lang="scss">
@use '../assets/sass/variables' as *;

.menu {
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0px;
  width: 100%;
  background-color: $pyroll-dark-blue !important;

  span {
    font-family: Ubuntu;
    font-size: 18px;
    font-weight: 400;
    color: white;
  }

  .pyroll-logo {
    height: 100px;

    &:hover {
      background-color: $pyroll-dark-blue;
    }

    .green-color {
      color: $pyroll-green !important;
      font-weight: bold;
    }
  }

  .i18n-buttons {
    font-size: 20px;
    font-family: $font-primary;
  }

  .bl-1 {
    border-left: 1px solid $font-color-primary;
  }

  .i18n-selected {
    font-family: $font-secondary;
  }

  .pm-title img {
    aspect-ratio: 8/3;
    height: 100%;
    max-height: 70px;

    @media screen and (max-width: 768px) {
      max-height: 45px;
    }
  }

  .pm-logo {
    &:hover {
      text-decoration: none;
    }
  }

  .navbar {
    max-width: 1640px;
    width: 100%;
    position: relative;

    @media (max-width: 768px) {
      padding-bottom: 10px;
      margin-bottom: 10px;
    }

    .navbar-start {
      padding: 10px 20px;

      .navbar-item {
        text-align: left;
        font-size: 18px;
        margin-bottom: 15px;

        @media (max-width: 768px) {
          text-align: center;
        }
      }
    }

    .home-image {
      width: 100%;
      margin: 0 auto;
    }

    .navbar-burger {
      background: white;
    }

    .navbar-item {
      &:hover {
        background-color: transparent;
      }
    }

    #navbarBasic {
      position: absolute;
      background: white;
      border: 1px solid #707070;
      right: -12px;
      top: 101px;
      width: 400px;
      z-index: 1;

      @media (max-width: 768px) {
        top: 88px;
        width: 100%;
        right: 0;
      }

      .navbar-start {
        display: block;
      }
    }

    .navbar-brand {
      width: 100%;
      flex-shrink: 1;
    }
  }
}

.shopping-cart-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  font-size: 20px;
  width: auto;
  padding: 0 12px;
  cursor: pointer;

  span.cart-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  svg,
  i {
    margin-left: 8px;
    vertical-align: middle;
  }

  // Desktop
  @media (min-width: 768px) {
    font-size: 24px;
    padding: 0 20px;

    svg,
    i {
      margin-left: 12px;
    }
  }

  // Mobile
  @media (max-width: 768px) {

    svg,
    i {
      margin-top: 4px;
    }
  }
}

/*
.popover {
  width: 100px;
  @media only screen and (min-width: 1000px) {
    width: 250px;
  }
}*/

.cart-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.cart-icon {
  position: relative;
  display: inline-flex;
}

.cart-count {
  position: absolute;
  top: -8px;
  left: 30px;
  transform: translateX(-50%);
  font-size: 12px !important;
  font-weight: bold;
  background: red;
  color: white;
  border-radius: 50%;
  line-height: 1;
  padding-left: 3px;
  width: 15px !important;
  height: 15px;
}

.popover-background {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1000;
  pointer-events: none;
}

.user-navigation {
  float: right;
}

.ribbon {
  height: 30px;
  width: 100%;
  background-color: $pyroll-violet;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    color: white;
    text-align: center;
  }
}

.green-ribbon {
  width: 100%;
  background-color: $pyroll-green;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    color: black;
    text-align: center;
  }
}

.navbar-brand,
.navbar-brand:focus,
.navbar-brand:active,
.navbar-brand:hover {
  background-color: transparent !important;
}

.navbar-link,
a.navbar-item {
  background-color: transparent !important;
}

.navbar-menu {
  background-color: transparent !important;
}

.navbar-burger {
  background-color: transparent !important;
}
</style>
